export default __webpack_public_path__ + "static/media/Check_Mark.835511b8.svg";